










































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import PermintaanObatPaketSvc from "@/services/PermintaanObatPaket";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import ObatComboField from "../ObatComboField.vue";
import { PAKET_OBAT, PaketObatConfig } from "./paketObat.config";

@Component({
  components: { CardModalTtd, ObatComboField },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class PaketObatForm extends Vue {
  @Prop({ type: String, required: true }) jenisPaket!: string;
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData!: any;
  // type: Boolean wajib eksplisit — emitDecoratorMetadata mati, atribut telanjang
  // akan masuk sebagai "" yang falsy dan diam-diam membuka mode read-only.
  @Prop({ type: Boolean, default: false }) readonly!: boolean;

  isReadOnly!: () => boolean;
  get editWindowReadOnly(): boolean {
    return this.isReadOnly();
  }

  get cfg(): PaketObatConfig {
    return PAKET_OBAT[this.jenisPaket];
  }

  saving = false;
  loadingDetail = false;
  modalTtd = false;
  currentData: any = null;

  form: any = {
    dpjp_id: null,
    diagnosa: "",
    jenis_bayar: "",
    has_alergi: false,
    alergi_detail: "",
    items: [],
    catatan: ""
  };

  get isLocked() {
    return this.readonly || this.editWindowReadOnly;
  }

  get dokterList() {
    return storeDokter.listAll;
  }

  async mounted() {
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }

    if (this.editData) {
      await this.loadDetail(this.editData.id);
    } else {
      await this.loadDefaultItems();
      this.autoFillFromStores();
    }
  }

  async loadDetail(id: number) {
    this.loadingDetail = true;
    try {
      const resp = await PermintaanObatPaketSvc.find(id);
      if (resp.data.status === "1") {
        this.currentData = resp.data.data;
        this.populateForm();
      }
    } catch {
      // handled by service
    }
    this.loadingDetail = false;
  }

  populateForm() {
    if (!this.currentData) return;
    const d = this.currentData;
    this.form = {
      dpjp_id: d.dpjp ? d.dpjp.id : null,
      diagnosa: d.diagnosa || "",
      jenis_bayar: d.jenis_bayar || "",
      has_alergi: d.has_alergi || false,
      alergi_detail: d.alergi_detail || "",
      items: (d.items || []).map((item: any) => ({ obat_id: null, ...item })),
      catatan: d.catatan || ""
    };
  }

  async loadDefaultItems() {
    try {
      const resp = await PermintaanObatPaketSvc.getDefaultItems(this.jenisPaket);
      if (resp.data.status === "1") {
        this.form.items = resp.data.data.map((item: any) => ({ obat_id: null, ...item }));
      }
    } catch {
      this.form.items = [];
    }
  }

  autoFillFromStores() {
    const reg = RegisterKunjungan.register;
    if (reg?.dokter?.id) this.form.dpjp_id = reg.dokter.id;

    const pasien = storePasien.identitasPasien;
    if (pasien?.register?.asr?.nama) this.form.jenis_bayar = pasien.register.asr.nama;
    if (pasien?.alergi) {
      this.form.has_alergi = true;
      this.form.alergi_detail = pasien.alergi;
    }

    const asesmen = AsesmenAwalRanapMedisStore.asesmen;
    if (asesmen?.diagnosis) this.form.diagnosa = asesmen.diagnosis;
  }

  addItem() {
    this.form.items.push({
      obat_id: null,
      nama_obat: "",
      signa: "",
      jml_standar: 0,
      tgl_no_r: "",
      jml_digunakan: null,
      jml_retur: null,
      catatan: ""
    });
  }

  removeItem(idx: number) {
    this.form.items.splice(idx, 1);
  }

  async doSave() {
    if (this.isLocked) return;
    if (!this.form.dpjp_id) { appModule.NoticeDelay("DPJP harus diisi"); return; }
    if (!this.form.diagnosa) { appModule.NoticeDelay("Diagnosa harus diisi"); return; }
    if (!this.form.items.length) { appModule.NoticeDelay("Minimal 1 item obat harus diisi"); return; }

    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        jenis_paket: this.jenisPaket,
        dpjp_id: this.form.dpjp_id,
        diagnosa: this.form.diagnosa,
        jenis_bayar: this.form.jenis_bayar,
        has_alergi: this.form.has_alergi,
        alergi_detail: this.form.has_alergi ? this.form.alergi_detail : null,
        items: this.form.items,
        catatan: this.form.catatan
      };

      if (this.currentData && this.currentData.id) {
        await PermintaanObatPaketSvc.update(this.currentData.id, payload);
        appModule.NoticeDelay("Berhasil mengupdate data");
      } else {
        await PermintaanObatPaketSvc.create(payload);
        appModule.NoticeDelay("Berhasil menyimpan data");
      }

      this.$emit("saved");
    } catch {
      // handled by service
    }
    this.saving = false;
  }

  openSignModal() {
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.currentData || !this.currentData.id) return;
    try {
      const resp = await PermintaanObatPaketSvc.signDpjp(this.currentData.id, { password });
      if (resp.data.status === "1") {
        this.modalTtd = false;
        appModule.NoticeDelay("Berhasil menandatangani sebagai DPJP");
        await this.loadDetail(this.currentData.id);
      }
    } catch {
      // handled by service
    }
  }
}
